import { Component, OnInit } from '@angular/core';
import { AuthService } from './../services/auth-service/auth.service'
import { Router } from '@angular/router'
import { User } from '../../../../../Leste 3.0/models/User'
import {Subscription, throwError} from 'rxjs';
import { UserLanguageService } from '../services/user-language-service/user-language.service';
import { MatDialog } from '@angular/material/dialog';
import { emailValidator, jmbgValidator } from '../../shared/helpers/validators.js';
import {environment} from '../../../environments/environment.prod';
import { LocalStorageService } from '../services/localStorage-service/local-storage.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import {MatSnackBar} from '@angular/material/snack-bar';
//import {ReCaptchaV3Service} from 'ng-recaptcha';
import {Folder} from '../../models/folder.model';
import {DashboardService} from '../dashboard.service';
import {MatIconModule} from '@angular/material/icon';

declare var FB: any
@Component({
    selector: 'app-register',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    standalone: false
})
export class RegistrationComponent implements OnInit {

  private user: User

  lang
  langSub: Subscription;

  labels;
  labelsSub: Subscription;

  err: boolean = false
  err1: boolean = false
  err2: boolean = false
  err3: boolean = false
  err4: boolean = false
  err5: boolean = false
  err6: boolean = false
  err7: boolean = false
  err8: boolean = false

  folders: Folder[]
  wrongInfo: boolean = false;

  backgroundClass: String = "backgroundLearning"
  header
  first: boolean = true
  second: boolean = false
  third: boolean = false
  showLoginPage: boolean = false
  hideSplashScreen: boolean =  false
  index: number = 1
  imageUrl: string
  captchaToken: string = ""

  isActive: boolean = true;
  rememberMe: boolean = false;
  constructor( private authService: AuthService, private router: Router, private languageService: UserLanguageService,
              public dialog: MatDialog,
              public snackBar: MatSnackBar,
              private localStorageService: LocalStorageService,
              //private recaptchaV3Service: ReCaptchaV3Service,
              private dashboardService: DashboardService) {
  }
  position
  checkedTOS: boolean = false;
  checkedData: boolean = false;

  ngOnInit(): void {

    this.rememberMe = this.localStorageService.getItem("rememberUser")

    if(this.localStorageService.getItem("rememberUser") == true && this.localStorageService.getItem("userName") != null && this.localStorageService.getItem("pass") != null) {
      this.onSubmit({email: this.localStorageService.getItem("userName"), password: this.localStorageService.getItem("pass")}, true);
    }

    this.dashboardService.getFolders().subscribe((folders: Folder[])=> {
      this.folders = folders
    })
    this.imageUrl = environment.registrationImagePath ?? "./assets/images/FOR-logo-new.png"
    this.position = "move"
    var w = window as any
    this.err = false;
    this.langSub = this.languageService.lang$.subscribe((lang) => {
      this.lang = lang;
    })
    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
    this.wrongInfo = false
    this.header = this.labels.lblLearning
    /*this.recaptchaV3Service.execute('user_registration')
      .subscribe((token) => {
        this.captchaToken = token
      });*/
  }
  onSubmit(formData, flg) {
    if(flg == true) {
      this.authService.register(formData).subscribe((response) => {
        if (response.err == "greska" || response.err == "notAccepted") {
          this.wrongInfo = true;
          this.router.navigateByUrl('/registration')
        }else {
          this.wrongInfo = false
          this.router.navigateByUrl('/')
          //this.router.navigateByUrl('/user/splash-screen')
        }
      })
    } else {
      if (!(formData.value.email && emailValidator(formData.value.email)) || !formData.value.firstName || !formData.value.lastName || !formData.value.accepted || !formData.value.checked
        || !(formData.value.jmbg && jmbgValidator(formData.value.jmbg)) || !formData.value.password
        || formData.value.password.length < 6 || !formData.value.confirmPassword || (formData.value.confirmPassword != formData.value.password))
      {
        this.err = true;
        console.log("ERRR 222", formData.value);
        if(!formData.value.email || !emailValidator(formData.value.email)){
          this.err1 = true
        }
        if(formData.value.password == "" || formData.value.password.length < 6){
          this.err2 = true
        }
        if (formData.value.firstName == "") {
          this.err3 = true
        }
        if (formData.value.lastName == "") {
          this.err4 = true
        }
        if (formData.value.jmbg === "" || !jmbgValidator(formData.value.jmbg)) {
          this.err5 = true
        }
        if (formData.value.city == "") {
          this.err6 = true
        }
        if (formData.value.phoneNumber == "") {
          this.err7 = true
        }
        if (formData.value.confirmPassword != formData.value.password) {
          this.err8 = true
        }
      } else {

        //formData.value.recaptcha_token = this.captchaToken
        this.authService.register(formData.form.value).subscribe((response) => {
          console.log("ERRR 1", response);
          if (response.err == "greska" || response.err == "notAccepted") {
            this.wrongInfo = true;
          } else {
            this.wrongInfo = false
            this.snackBar.open(this.labels.lblSignUpMessage, 'OK',{
              verticalPosition: 'top',
              horizontalPosition: 'end',
              duration: 5000
            })
            this.router.navigateByUrl('/login')
            // this.router.navigateByUrl('/user/splash-screen')
          }
        }, error => {
          console.log(error)
          this.wrongInfo = true;
          if(error.status === 500) {
            this.snackBar.open(this.labels.lblSignUpWrongDataMessage, 'OK', {
              verticalPosition: 'top',
              horizontalPosition: 'end',
              duration: 5000
            })
          }
          if(error.status === 400) {
            if(error.error.err === "Your action has been detected as suspicious. Please try again.") {
              this.snackBar.open(this.labels.lblCaptchaFailed, 'OK', {
                verticalPosition: 'top',
                horizontalPosition: 'end',
                duration: 5000
              })
            } else if(error.error.message === "Invalid email") {
              this.err1 = true
              this.snackBar.open(this.labels.lblInvalidEmail, 'OK', {
                verticalPosition: 'top',
                horizontalPosition: 'end',
                duration: 5000
              })
            } else if (error.error.message === "User with that JMBG already exists") {
              this.err5 = true
              this.snackBar.open(this.labels.lblJMBGAlreadyExists, 'OK', {
                verticalPosition: 'top',
                horizontalPosition: 'end',
                duration: 5000
              })
            }
            else {
              this.snackBar.open(this.labels.lblSignUpUserAlreadyExists, 'OK', {
                verticalPosition: 'top',
                horizontalPosition: 'end',
                duration: 5000
              })
            }

          }
        }, () => {
          /*this.recaptchaV3Service.execute('user_registration')
            .subscribe((token) => {
              this.captchaToken = token
            });*/
        })
      }
    }
  }

  goToLogin(){
    this.showLoginPage = true
    this.hideSplashScreen = true
    this.localStorageService.setItem("splashScreenLoaded", true)
  }

  selectLang(lang) {
    this.languageService.setLanguage(lang);
  }


  changeActive(){
    this.isActive = !this.isActive;
  }

  onRememberMeClick($event: MatSlideToggleChange) {
    this.rememberMe = !this.rememberMe;
    console.log("REMEMBER ME: ", this.rememberMe);
    this.localStorageService.setItem("rememberUser", this.rememberMe);
  }

  ngOnDestroy() {
    this.langSub.unsubscribe();
    this.labelsSub.unsubscribe();
  }
}
